module.exports = __webpack_public_path__ + "img/bg1.d7abe8a1.png";